import { Component, inject, signal } from '@angular/core';
import { AlertMessage, AlertService } from './alert.service';

@Component({
  selector: 'app-alert-component',
  imports: [],
  templateUrl: './alert-component.html',
})
export class AlertComponent {
  alert = signal<AlertMessage | null>(null);

  constructor() {
    const service = inject(AlertService);
    service.alert$.subscribe((msg) => this.alert.set(msg));
  }
}
